import { useMutation, useQueryClient } from "@tanstack/react-query";
import { syncBusinessInterests } from "../../../apis";
import { Storage } from "common/storage";

export function useSyncBusinessInterest() {
  const accessToken = Storage.getCurrentUserToken();
  
  const queryClient = useQueryClient();
  const { data, error, mutate, status } = useMutation({
    mutationFn: ({
      businessId,
      interestType,
      notifyAccessibilityInformation,
      notifyLiveAlert,
      action,
      interestId,
    }: {
      businessId: string;
      interestType: string;
      notifyAccessibilityInformation: boolean;
      notifyLiveAlert: boolean;
      action: "create" | "update" | "delete";
      interestId?: string;
    }) => {
      return syncBusinessInterests(
        businessId,
        interestType,
        notifyAccessibilityInformation,
        notifyLiveAlert,
        accessToken || "",
        action,
        interestId
      );
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["homePins"],
        exact: false,
      });
      await queryClient.invalidateQueries({
        queryKey: ["loadVenueDetailsBySlug"],
        exact: false,
      });
      await queryClient.invalidateQueries({
        queryKey: ["businessInterests"],
        exact: false,
      });
    },
  });
  return { data, error, isLoading: status === "pending", mutate };
}
